export const generateDateRange = (days = 30): Date[] => {
  const dates = [];
  const now = new Date();
  const nyDateString = now.toLocaleDateString('en-US', { timeZone: 'America/New_York' });
  const today = new Date(nyDateString); 

  for (let i = 0; i < days; i++) {
    const date = new Date(today);
    date.setDate(today.getDate() + i);
    dates.push(date);
  }
  return dates;
};

export const formatDate = (date: Date): string => {
  return new Intl.DateTimeFormat('en-US', { 
    weekday: 'short', 
    month: 'short', 
    day: 'numeric' 
  }).format(date);
};

export const dateToKey = (date: Date): string => {
  return date.toLocaleDateString('en-CA', {
    timeZone: 'America/New_York',
    year: 'numeric',
    month: '2-digit',
    day: '2-digit'
  });
};

export const calculateEndTime = (startTime: string, durationMinutes: number | string): string => {
  const finalDuration = typeof durationMinutes === 'string' ? 0 : durationMinutes;
  if (!startTime || finalDuration < 0) return '';
  const [hStr, mStr] = startTime.split(':');
  const h = parseInt(hStr, 10);
  const m = parseInt(mStr, 10);
  
  if (isNaN(h) || isNaN(m)) return '';

  const totalMinutes = h * 60 + m + finalDuration;
  const endH = Math.floor(totalMinutes / 60) % 24;
  const endM = totalMinutes % 60;
  
  return `${String(endH).padStart(2, '0')}:${String(endM).padStart(2, '0')}`;
};

export const formatGoogleCalendarTime = (date: string, time: string): string => {
  const datePart = date.replace(/-/g, '');
  const timePart = time.replace(/:/g, '') + '00';
  return datePart + 'T' + timePart;
};
